import posthog from 'posthog-js';

export const initPosthog = () => {
  // eslint-disable-next-line no-underscore-dangle
  if (window.isDev || !process.env.VUE_APP_POSTHOG_KEY || posthog.__loaded) {
    return;
  }
  const token = process.env.VUE_APP_POSTHOG_KEY;
  const apiHost = process.env.VUE_APP_POSTHOG_HOST || 'https://us.i.posthog.com';

  posthog.init(token, {
    api_host: apiHost,
    autocapture: false,
  });
};

// eslint-disable-next-line no-underscore-dangle
const isInitialized = () => posthog.__loaded && !window.isDev && !!localStorage.getItem('ins-token');

export const logPosthogEvent = (eventName, data = {}) => {
  if (!isInitialized()) return;
  posthog.capture(eventName, data);
};

// Captures events during the login flow, where there is no stored `ins-token` yet
// (so the regular `isInitialized` token gate would drop the event). Ensures posthog
// is initialized first. Respects the same env guards as `initPosthog`.
export const logPosthogLoginError = (eventName, data = {}) => {
  if (window.isDev || !process.env.VUE_APP_POSTHOG_KEY) return;
  // eslint-disable-next-line no-underscore-dangle
  if (!posthog.__loaded) {
    initPosthog();
  }
  // eslint-disable-next-line no-underscore-dangle
  if (!posthog.__loaded) return;
  posthog.capture(eventName, data);
};

export const identifyPosthogUser = (user, companyDetails = null) => {
  if (!user) return;
  // eslint-disable-next-line no-underscore-dangle
  if (!posthog.__loaded) {
    initPosthog();
  }
  if (!isInitialized()) return;
  const providerName = companyDetails?.name;
  posthog.identify(user.id, {
    email: user.profile.email,
    provider_id: companyDetails?.id,
    provider_type: user?.providerType,
    provider_name: providerName,
    project_name: `${window.whiteLabelCompany}-admin`,
  });

  posthog.register({
    provider_id: companyDetails?.id,
    provider_name: providerName,
    is_test: !!(providerName?.toLowerCase()
      .includes('test') || providerName?.toLowerCase()
      .includes('demo')),
  });
  posthog.set_config({
    autocapture: true,
  });
};

export const resetPosthog = () => {
  // eslint-disable-next-line no-underscore-dangle
  if (posthog.__loaded) {
    posthog.set_config({
      autocapture: false,
    });
  }
};

export default posthog;
